import { ExternalLink } from "../components/external-link";

const SELECTORS = {
  externalLinkHttp: 'a[href^="http://"]:not([href*="uottawa.ca"])',
  externalLinkHttps: 'a[href^="https://"]:not([href*="uottawa.ca"])',
  richText: ".rich-text",
};

const TYPES = {
  richText: "rich_text",
};

window.Drupal.behaviors.external_links = {
  attach: (context, settings) => {
    const richTextcomponents = [
      ...context.querySelectorAll(
        `${SELECTORS.richText} ${SELECTORS.externalLinkHttp},${SELECTORS.richText} ${SELECTORS.externalLinkHttps}`,
      ),
    ];
    for (const component of richTextcomponents) {
      const ExternalLinkInstance = new ExternalLink(component, TYPES.richText);
      ExternalLinkInstance.init();
    }
  },
};
